import { EntityType } from '@frontend/common';
import { NotificationContentClient } from '@frontend/notification/api';
import { CreateNotificationContent, NotificationContent } from '@frontend/notification/types';
import { FormattedMessage } from 'react-intl';

import CreateModal from '../../../../../modal/create-modal/create-modal.component';
import { useCreateContentModal } from './create-content-modal.controller';

export interface CreateContentModalProps {
    templateId: string;
    onClose: () => void;
}

export const CreateContentModal = (props: CreateContentModalProps) => {
    const viewProps = useCreateContentModal();

    return (
        <CreateModal<NotificationContent, CreateNotificationContent>
            order={['language', 'channel']}
            required={['language', 'channel']}
            enumOverwrite={new Map([['channel', 'notification_channel']])}
            type={EntityType.NOTIFICATION_TEMPLATE}
            onSubmit={(v) => NotificationContentClient.postNotificationContent(viewProps.currentAccount, props.templateId, { ...v, body: '' })}
            formId={viewProps.contentModalId}
            label={
                <FormattedMessage
                    id='notifications.contents.create-content'
                    defaultMessage='Create notification content'
                />
            }
            submitDisabled={(v) => !v.language || !v.channel}
            additionalSubmit={{
                label: (
                    <FormattedMessage
                        id='notifications.contents.submit-and-edit'
                        defaultMessage='Submit and edit'
                    />
                ),
                onClick: (v) => NotificationContentClient.postNotificationContent(viewProps.currentAccount, props.templateId, { ...v, body: '' }),
                onSubmitSuccess: (value) => {
                    viewProps.navigate(`/notifications/templates/${value.template_id}/content/${value.id}/details`);
                    props.onClose();
                }
            }}
        />
    );
};
